import { useContext, useEffect, useState } from 'react'
import Spinner from 'react-bootstrap/Spinner'
import { SetupContext } from 'src/consumer/context/SetupContext'
import { getCategoryListMap } from 'src/consumer/helpers/courseCardHelper'
import { getDataWithoutParams } from 'src/consumer/services/featureServices'
import {
  LoadingIconGroup,
  NewAssessmentItem,
  NewJournalItem,
  UnderlinedText,
} from '../JournalComponents'
import {
  BrowseInternalContainer,
  BrowseModalHeading,
  ScreenBackground,
  StyledInfiniteScroll,
  ToggleButton,
  ToggleButtonsContainer,
} from '../JournalStyles'

export default function BrowseJournals(props) {
  const { setParentModalState, setNewEntryData } = props
  const [pageState, setPageState] = useState('loading')
  const [browseJournalsData, setBrowseJournalsData] = useState([])
  const [browseAssessmentsData, setBrowseAssessmentsJournalsData] = useState([])
  const { setupData } = useContext(SetupContext)
  const categoryMap = getCategoryListMap(setupData)
  const [pageOfJournals, setPageOfJournals] = useState(2)
  const [hasMoreJournals, setHasMoreJournals] = useState(true)
  const [pageOfAssessments, setPageOfAssessments] = useState(2)
  const [hasMoreAssessments, setHasMoreAssessments] = useState(true)
  const [chosenBrowsingOption, setChosenBrowsingOption] = useState('journals')

  async function pageSetupForJournals() {
    setPageState('loading')
    const response = await getDataWithoutParams(`/api/secure/journals?page=1&pageSize=10`)
    if (response?.status === 200) {
      setBrowseJournalsData([{ type: 'blank' }, ...response?.data])
      setPageState('browse')
    }
  }

  async function pageSetupForAssessments() {
    setPageState('loading')
    const response = await getDataWithoutParams(`/api/secure/assessments?page=1&pageSize=10`)
    if (response?.status === 200) {
      setBrowseAssessmentsJournalsData(response?.data)
      setPageState('browse')
    }
  }

  async function fetchJournalsData() {
    const response = await getDataWithoutParams(
      `/api/secure/journals?page=${pageOfJournals}&pageSize=10`,
    )
    if (response?.status === 200) {
      if (response?.data?.length === 0) {
        setHasMoreJournals(false)
      }
      setBrowseJournalsData([...browseJournalsData, ...response?.data])
    }
    setPageOfJournals((prev) => prev + 1)
  }

  async function fetchAssessmentsData() {
    const response = await getDataWithoutParams(
      `/api/secure/assessments?page=${pageOfAssessments}&pageSize=10`,
    )
    if (response?.status === 200) {
      if (response?.data?.length === 0) {
        setHasMoreAssessments(false)
      }
      setBrowseAssessmentsJournalsData([...browseAssessmentsData, ...response?.data])
    }
    setPageOfAssessments((prev) => prev + 1)
  }

  useEffect(() => {
    if (chosenBrowsingOption === 'journals') {
      pageSetupForJournals()
    }
    if (chosenBrowsingOption === 'assessments') {
      pageSetupForAssessments()
    }
  }, [chosenBrowsingOption])

  return (
    <ScreenBackground>
      <BrowseModalHeading>Browse</BrowseModalHeading>
      <UnderlinedText
        backText="Go back to previous page"
        setParentModalState={setParentModalState}
      />

      <ToggleButtonsContainer>
        <ToggleButton
          selected={chosenBrowsingOption === 'journals'}
          onClick={() => setChosenBrowsingOption('journals')}
        >
          Journals
        </ToggleButton>
        <ToggleButton
          selected={chosenBrowsingOption === 'assessments'}
          onClick={() => setChosenBrowsingOption('assessments')}
        >
          Assessments
        </ToggleButton>
      </ToggleButtonsContainer>

      {pageState === 'browse' ? (
        <BrowseInternalContainer id="scrollableDiv">
          {chosenBrowsingOption === 'journals' && (
            <StyledInfiniteScroll
              dataLength={browseJournalsData?.length} //This is important field to render the next data
              next={fetchJournalsData}
              hasMore={hasMoreJournals}
              loader={<Spinner animation="border" variant="dark" size="md" />}
              scrollableTarget="scrollableDiv"
            >
              {browseJournalsData?.map((journalItem, index) => {
                return (
                  <NewJournalItem
                    key={index}
                    data={journalItem}
                    category={categoryMap?.get('myJournal')}
                    setParentModalState={setParentModalState}
                    setNewEntryData={setNewEntryData}
                  />
                )
              })}
            </StyledInfiniteScroll>
          )}

          {chosenBrowsingOption === 'assessments' && (
            <StyledInfiniteScroll
              dataLength={browseAssessmentsData?.length} //This is important field to render the next data
              next={fetchAssessmentsData}
              hasMore={hasMoreAssessments}
              loader={<Spinner animation="border" variant="dark" size="md" />}
              scrollableTarget="scrollableDiv"
              justifyCenter={true}
            >
              {browseAssessmentsData?.map((assessmentItem, index) => {
                if (assessmentItem?.enabled) {
                  return (
                    <NewAssessmentItem
                      key={index}
                      data={assessmentItem}
                      category={categoryMap?.get('assessment')}
                    />
                  )
                } else {
                  return null
                }
              })}
            </StyledInfiniteScroll>
          )}
        </BrowseInternalContainer>
      ) : (
        <LoadingIconGroup />
      )}
    </ScreenBackground>
  )
}
